import { render, staticRenderFns } from "./UserEditPassword.vue?vue&type=template&id=57948ce3&"
import script from "./UserEditPassword.vue?vue&type=script&lang=js&"
export * from "./UserEditPassword.vue?vue&type=script&lang=js&"
import style0 from "./UserEditPassword.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports